export enum Scrollbars {
    HORIZONTAL = 501,
    VERTICAL = 502,
}
